/**
 * Enables labels with a tabindex to check their relevant control when they are clicked
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/events/trigger/trigger.js";

export default obj => {
	obj.on("keypress", function (e) {
		if (["Enter", " "].indexOf(e.key) > -1) {
			$("#" + $(this).attr("for")).prop("checked", true).trigger("change");
		}
	});
};
